import React, { useState } from 'react'
import { ButtonRounded, Notification } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import { FeatureSwitch } from '../../../../utils/features/featureSwitches'
import { useFeatureSwitch } from '../../../../utils/features/FeatureSwitchContext'
import { IconS24Upload48 } from '@is24/cosma-ui-icons'
import { useAppSelector } from '../../../../app/hooks'
import { InitState } from '../../../../redux/reducers/root/initialState'
import { isEditEntryMode } from '../../../../@types/types'
import { AiDataExtractionUploadModal } from './AiDataExtractionUploadModal'

export const AiDataExtractionBanner = () => {
  const { t } = useTranslation()
  const { isActive: isAiDataExtractionBannerEnabled } = useFeatureSwitch(
    FeatureSwitch.PPA_12241_AI_DATA_EXTRACTION_BANNER
  )
  const entryMode = useAppSelector(
    (state: InitState) => state.insertionFeature.insertionIdentification.metaInformation?.entryMode
  )
  const isAiDataExtractionSupported = useAppSelector(
    (state: InitState) => state.flowFeature.flowInformation.options?.hasAiDataExtractionBanner
  )
  const isEditFlow = isEditEntryMode(entryMode)
  const [dismissedInSession, setDismissedInSession] = useState(false)
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false)

  if (!isAiDataExtractionBannerEnabled || dismissedInSession || isEditFlow || !isAiDataExtractionSupported) {
    return null
  }

  return (
    <div className='margin-bottom-l' data-testid='ai-data-extraction-banner'>
      <Notification
        title={t('wizard.uploadAiBanner.title')}
        message={t('wizard.uploadAiBanner.message')}
        type={'neutral'}
        variant={'flat'}
        onClose={() => setDismissedInSession(true)}
        actionButton={
          <ButtonRounded
            label={t('wizard.uploadAiBanner.cta')}
            variant={'filledWeak'}
            rightIcon={<IconS24Upload48 />}
            onClick={() => setIsUploadModalOpen(true)}
          />
        }
      />
      <AiDataExtractionUploadModal isOpen={isUploadModalOpen} onClose={() => setIsUploadModalOpen(false)} />
    </div>
  )
}
